import $ from "jquery";
let throttler;

export class ImpactSlideshow {
  constructor($el) {
    this.$el = $el;
    this.$image = this.$el.find(".impact-slideshow__image").first();
    this.$title = this.$el.find(".impact-slideshow__title");
    this.$mobileTitle = this.$el.find(".impact-slideshow__title-mobile");
    this.$navSlider = this.$el.find(".js-slider-nav-wrapper");
    this.$richText = this.$el.find(".slideshow__rich-text");
    this.$slickNext = this.$el.find(".slick-next");
    this.$slickPrev = this.$el.find(".slick-prev");
    this.$slickDots = this.$el.find(".slick-dots li");
    this.currentSlide = 0;
    this.numberOfSlides = this.$richText.length;
    this.arrowEventsBound = false;
    this.previousWindowWidth = $(window).width();

    this.init();
  }

  init() {
    this.bindEvents();
    this.bindArrowEvents();
    this.bindSlickChange();
    this.positionNavSlider();
  }

  bindEvents() {
    $(window).on("resize", () => {
      console.log($(window).width(), "Window Width on Resize");
      if (throttler) clearTimeout(throttler);

      throttler = setTimeout(() => {
        const currentWidth = $(window).width();
        const crossedToDesktop = this.previousWindowWidth <= 1168;

        this.positionNavSlider();

        if ((crossedToDesktop || !this.arrowEventsBound) && currentWidth > 1168) {
          this.bindArrowEvents();
        }
        
        this.previousWindowWidth = currentWidth;
      }, 100);
    });
  }

  bindArrowEvents() {
    this.$slickNext.off("click").on("click", () => {
      this.$el.find(".js-slider").slick("slickNext");
    });

    this.$slickPrev.off("click").on("click", () => {
      this.$el.find(".js-slider").slick("slickPrev");
    });

    this.arrowEventsBound = true;
  }

  bindSlickChange() {
    const $slider = this.$el.find(".js-slider");

    if ($slider.length && typeof $slider.on === "function") {
      $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
        this.currentSlide = nextSlide;
        this.positionNavSlider();
      });
    }
  }

  positionNavSlider() {
    var windowWidth = $(window).width();
    const currentRichText = this.$richText.eq(this.currentSlide);
    const richTextHeight = currentRichText.outerHeight(true) || 0;
    const imageHeight = this.$image.height();

    console.log(windowWidth, "Window Width");
    if (windowWidth >= 1168 - 15) {
      console.log("Desktop view 1168");
      this.$navSlider.css("top", richTextHeight + 10);
      this.$el.height(richTextHeight + 95);
    } else {
      console.log("else");
      const mobTitleHeight = this.$mobileTitle.outerHeight(true) || 0;
      const imageOffset = (imageHeight + mobTitleHeight) * 1.025;

      this.$navSlider.css("top", imageOffset);
      this.$el.height(imageHeight + mobTitleHeight + richTextHeight + 95);
    }
  }
}
